import { createSelector } from '@reduxjs/toolkit';
import { getStore } from '../../reducers';

const getAssetLink = createSelector(getStore, (store) => store.assetLink);

export const getInProgress = createSelector(getAssetLink, (assetLink) => assetLink.inProgress);
